import * as datGui from 'dat.gui'
import { Camera, Renderer, Scene } from 'three'
import { createControlsGui } from './createControls.gui'
import { SceneLight } from '../../types/scene-light'
import { addColorChangeGui } from './addColorChange.gui'
import { StoreScheme } from '../../../shared/store/store'

export function addLightsGUI(
  gui: datGui.GUI,
  lights: SceneLight[],
  scene: Scene,
  camera: Camera,
  renderer: Renderer,
  store: StoreScheme,
) {
  const rootFolder = gui.addFolder('Light')
  lights.forEach((light) => {
    const lightFolder = rootFolder.addFolder(light.name)
    lightFolder.add(light, 'intensity', 0, 5).name('Intensity')
    addColorChangeGui(light.color, lightFolder)
    createControlsGui(lightFolder, `Transform helper`, light, scene, camera, renderer, store)
  })
}
